import { JSX } from 'react';

const IconChevronwRight = (): JSX.Element => {
  return (
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M6.85355 0.146447C7.04882 0.341709 7.04882 0.658291 6.85355 0.853553L1.20711 6.5L6.85355 12.1464C7.04882 12.3417 7.04882 12.6583 6.85355 12.8536C6.65829 13.0488 6.34171 13.0488 6.14645 12.8536L0.146447 6.85355C-0.0488155 6.65829 -0.0488155 6.34171 0.146447 6.14645L6.14645 0.146447C6.34171 -0.0488155 6.65829 -0.0488155 6.85355 0.146447Z"
      fill="currentColor"
    />
  );
};

export default IconChevronwRight;
